import { showError } from 'src/utils/debug-log';

// utils/storage-data.js
const readJsonFile = async (fileName) => {
  try {
    const response = await fetch(
      `${process.env.PUBLIC_URL}/storage/${fileName}`,
    );
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return await response.json();
  } catch (error) {
    throw error; // Re-throw the error so it can be handled by the caller
  }
};

// Get vihicle
export const getVehicle = async () => {
  const json = {
    transmission: [],
    brandName: [],
    carName: {},
  };

  try {
    const data = await readJsonFile('vehicle.json');

    // Extract transmission data
    json.transmission = data.transmission || [];

    // Remove transmission from the main data
    const { transmission, ...result } = data;

    json.carName = result;

    // Create an array of brand objects with 'value' and 'label'
    const brandArray = Object.keys(result).map((brand) => ({
      value: brand.toLowerCase(),
      label: brand.charAt(0).toUpperCase() + brand.slice(1),
    }));
    json.brandName = brandArray;
  } catch (error) {
    showError(error);
  }
  return json;
};

// Get partner type
export const getPartnerType = async () => {
  try {
    return readJsonFile('partner_type.json');
  } catch (error) {
    showError(error);
    return [];
  }
};

// Get partner type
export const getKeysMapping = async () => {
  try {
    return readJsonFile('keys_mapping.json');
  } catch (error) {
    showError(error);
    return [];
  }
};
